/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_EnableInputs */

const cs_portals_check_enable = /** @type {(inputs: Portals_Check_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnout export`)
};

const en_portals_check_enable = /** @type {(inputs: Portals_Check_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable export`)
};

/**
* | output |
* | --- |
* | "Enable export" |
*
* @param {Portals_Check_EnableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_enable = /** @type {((inputs?: Portals_Check_EnableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_EnableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_enable(inputs)
	return cs_portals_check_enable(inputs)
});